import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/appsebrae/fornecedores/consultorias`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/pagamentos?dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterConsultoriasDisponiveis(pagamentoId) {
        return axiosJwt
            .get(`${api}/pagamentos/${pagamentoId}/consultoriasdisponiveis`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    associarConsultorias(pagamentoConsultorias) {
        return axiosJwt
            .post(
                `${api}/pagamentos/${pagamentoConsultorias.pagamentoId}/associarconsultorias`,
                pagamentoConsultorias
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    desassociarConsultoria(pagamentoConsultoria) {
        return axiosJwt
            .post(
                `${api}/pagamentos/${pagamentoConsultoria.pagamentoId}/desassociarconsultoria`,
                pagamentoConsultoria
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamento() {
        return axiosJwt
            .post(`${api}/pagamentos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos() {
        return axiosJwt
            .get(`${api}/pagamentos/anexos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoAnexo(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoId', pagamentoAnexo.tipoId)
        formData.append('descritivo', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)

        return axiosJwt
            .post(
                `${api}/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(pagamentoAnexo) {
        return axiosJwt
            .put(
                `${api}/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                pagamentoAnexo
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    enviarPagamentoParaAnalise(pagamentoDto) {
        return axiosJwt
            .post(`${api}/pagamentos/enviar`, pagamentoDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(`${api}/pagamentos/anexos/${pagamentoAnexoId}`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
